import React from 'react';
import { actions } from './Dialog';
import { InfoMessage } from './texts';
import Button from '@material-ui/core/Button';
import Dialog from '../../BuildingBlocks/Dialogs/DialogStyleTwo/Dialog';

export default function EditStagesConfirmation({
  setOptionNumber,
  open,
  endRequest = null,
}) {
  const header = 'Edit Active Line';

  const content =
    'Editing an Active Line may result in a re-calculation, which can take up to 48 hours. Your Active Growth Plan will remain in effect until you approve any change.';

  const action = (
    <Button
      variant="contained"
      color="primary"
      onClick={() => setOptionNumber(actions.editStages)}
    >
      <b>Continue</b>
    </Button>
  );

  return (
    <Dialog
      open={open}
      header={header}
      description={content}
      actions={action}
      onClose={endRequest}
      info={InfoMessage}
    />
  );
}
